import React from "react";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Link from "@material-ui/core/Link";
import clsx from "clsx";
import ConfirmationCheckIcon from "./ConfirmationCheckIcon";
import { useTheme } from "@material-ui/styles";
import { redirectToShop, openLabel } from "../../../shared/modules/frame";
import { makeRootStyles } from "../../theme/styles";
import StyledMarkup from "../../ReviewSummary/components/StyledMarkup";

const useStyles = makeRootStyles(
  (theme) => ({
    root: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(12),
      display: "flex",
      alignItems: "center",
    },
    checkIcon: {
      display: "flex",
      justifyContent: "center",
      textAlign: "center",
      fontSize: "5rem",
    },
    gutterBottom: {
      marginBottom: theme.spacing(4),
      [theme.breakpoints.up("md")]: {
        marginBottom: theme.spacing(2),
      },
    },
    labelButton: {
      marginBottom: theme.spacing(2),
    },
  }),
  { name: "N0ConfirmationBasic" },
);

function ConfirmationBasic({
  renderInAppLabel,
  show,
  submitResult,
  supplementaryText,
  printLabelText,
  renderSupplementaryText,
  title,
  subtitle,
  buttonTitle,
}) {
  const theme = useTheme();
  const classes = useStyles();

  return (
    <Fade in={show} timeout={800}>
      <div className={classes.root}>
        <Grid justifyContent="center" spacing={2} container>
          <Grid xs={12} item>
            <div className={clsx(classes.checkIcon, classes.gutterBottom)}>
              <ConfirmationCheckIcon color={theme.palette.primary.main} />
            </div>
            <Typography
              className={classes.gutterBottom}
              align="center"
              variant="h1">
              {title}
            </Typography>
            <Typography
              className={classes.gutterBottom}
              align="center"
              variant="body1">
              <StyledMarkup content={subtitle} />
            </Typography>
            {renderSupplementaryText && (
              <Typography
                className={classes.gutterBottom}
                align="center"
                variant="body1">
                {supplementaryText}
              </Typography>
            )}
          </Grid>
          {renderInAppLabel && (
            <Grid xs={12} sm={8} md={6} lg={4} item>
              <Link
                onClick={() => openLabel(submitResult)}
                target="_blank"
                underline="none">
                <Button
                  id="confirmation-shipping-label"
                  className={classes.labelButton}
                  color="primary"
                  size="large"
                  variant="contained"
                  fullWidth>
                  {printLabelText}
                </Button>
              </Link>
              <Typography align="center">
                <Link
                  id="confirmation-continue-shopping"
                  onClick={redirectToShop}>
                  {buttonTitle}
                </Link>
              </Typography>
            </Grid>
          )}
          {!renderInAppLabel && (
            <Grid xs={12} sm={8} md={6} lg={4} item>
              <Button
                id="confirmation-continue-shopping"
                color="primary"
                onClick={redirectToShop}
                size="large"
                variant="contained"
                fullWidth>
                {buttonTitle}
              </Button>
            </Grid>
          )}
        </Grid>
      </div>
    </Fade>
  );
}

export default ConfirmationBasic;
